import Vue from 'vue'
import Router from 'vue-router'
import ItemList from './views/ItemList.vue'
//import Home from './views/Home.vue'
import  { Logger } from 'aws-amplify';
const logger = new Logger('Router','INFO');
import store from './store.js'
// Google Analytics cowry AirDT agurobaisen web
Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, ) {//from, savedPosition
    if(to.name == "itemListRoot" && to.hash){
      logger.info("since hash no work well. we load pos from session storage")
      //sessionStorage.setItem("itemListMousePos",JSON.stringify({pos:pos,time:Date.now()}))
      if(sessionStorage.getItem('itemListMousePos')){
        const posData = JSON.parse(sessionStorage.getItem('itemListMousePos'))
        logger.info("posData",posData)
        if(posData.posY >= 0){
          return {x:0,y:posData.posY}
        }else{
          return { x: 0, y: 0 }
        }

      }else{
        return { x: 0, y: 0 }
      }

    }else{
      return { x: 0, y: 0 }
    }


    // Below does not work on older vue version. try after upgrade
    /*
    logger.info("scrollBehavior to",to)

    if (to.hash ) {
      logger.info("going to hash",to.hash)
      logger.info("document.querySelector(to.hash)",document.querySelector(to.hash))
      return {
        offset: {y:200}
      }
    }else{
      return { x: 0, y: 0 }
    }

     */
  },
  routes: [
    {
      path: '/',
      name: 'itemListRoot',
      component:ItemList
    },
    {
      path: '/itemList',
      name: 'itemList',
      component:ItemList
    },
    {
      path: '/home',
      name: 'home',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "home" */ './views/Home.vue')
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/detail',
      name: 'detail',

      component: () => import(/* webpackChunkName: "about" */ './views/Detail.vue')
    },
    {
      path: '/cart',
      name: 'cart',

      component: () => import(/* webpackChunkName: "about" */ './views/Cart.vue')
    },
    {
      path: '/setDateTimeMethod',
      name: 'setDateTimeMethod',

      component: () => import(/* webpackChunkName: "about" */ './views/SetDateTimeMethod.vue'),
      beforeEnter: (to,from,next) => {
        //const dp = store.getters.getDeliveryProvider
        const dp = store.state.deliveryProvider
        logger.info("router deliveryProvider",dp)
        try{
          if(dp.dpId){
            next({name:'dpConsent'})
          }else {
            next()
          }
        }catch(e){
          logger.info("router err",e)
        }

      }
    },
    {
      path: '/dpConsent',
      name: 'dpConsent',

      component: () => import(/* webpackChunkName: "dpSetDateTime" */ './views/DpConsent.vue'),
      beforeEnter: (to,from,next) => {
        try{
          const dp = store.state.deliveryProvider
          if(dp.dpId){
            next()
          }else {
            next("/")
          }
        }catch(e){
          logger.info("router err",e)
        }
      }
    },
    {
      path: '/dpSetCustomerDetail',
      name: 'dpSetCustomerDetail',

      component: () => import(/* webpackChunkName: "dpSetDateTime" */ './views/DpSetCustomerDetail.vue'),
      beforeEnter: (to,from,next) => {
        try{
          const dp = store.state.deliveryProvider
          if(dp.dpId){
            next()
          }else {
            next("/")
          }
        }catch(e){
          logger.info("router err",e)
        }
      }
    },
    {
      path: '/dpSetGps',
      name: 'dpSetGps',

      component: () => import(/* webpackChunkName: "dpSetDateTime" */ './views/DpSetGps.vue'),
      beforeEnter: (to,from,next) => {
        try{
          const dp = store.state.deliveryProvider
          if(dp.dpId){
            next()
          }else {
            next("/")
          }
        }catch(e){
          logger.info("router err",e)
        }
      }
    },
    {
      path: '/dpSetDateTime',
      name: 'dpSetDateTime',

      component: () => import(/* webpackChunkName: "dpSetDateTime" */ './views/DpSetDateTime.vue'),
      beforeEnter: (to,from,next) => {
        try{
          const dp = store.state.deliveryProvider
          if(dp.dpId){
            next()
          }else {
            next("/")
          }
        }catch(e){
          logger.info("router err",e)
        }
      }
    },
    {
      path: '/dpSetDestination',
      name: 'dpSetDestination',

      component: () => import(/* webpackChunkName: "dpSetDestination" */ './views/DpSetDestination.vue'),
      beforeEnter: (to,from,next) => {
        try{
          const dp = store.state.deliveryProvider
          if(dp.dpId){
            next()
          }else {
            next("/")
          }
        }catch(e){
          logger.info("router err",e)
        }
      }
    },
    {
      path: '/dpCheckout',
      name: 'dpCheckout',

      component: () => import(/* webpackChunkName: "dpCheckout" */ './views/DpCheckout.vue'),
      beforeEnter: (to,from,next) => {
        try{
          const dp = store.state.deliveryProvider
          if(dp.dpId){
            next()
          }else {
            next("/")
          }
        }catch(e){
          logger.info("router err",e)
        }
      }
    },
    {
      path: '/orderDetailDp',
      name: 'orderDetailDp',
      component: () => import(/* webpackChunkName: "orderDetailDp" */ './views/OrderDetailDp.vue'),
    },
    {
      path: '/checkout',
      name: 'checkout',

      component: () => import(/* webpackChunkName: "checkout" */ './views/Checkout.vue')
    },
    {
      path: '/history',
      name: 'history',

      component: () => import(/* webpackChunkName: "history" */ './views/History.vue')
    },
    {
      path: '/orderDetail',
      name: 'orderDetail',

      component: () => import(/* webpackChunkName: "about" */ './views/OrderDetail.vue')
    },
    {
      path: '/settings',
      name: 'settings',

      component: () => import(/* webpackChunkName: "about" */ './views/Settings.vue')
    },

    {
      path: '/bizHours',
      name: 'bizHours',

      component: () => import(/* webpackChunkName: "about" */ './views/BizHours.vue')
    }
  ]
})


